<template>
    <div class="tech">
        <div class="ch-title">
            <div class="ch-title-top">
                <img src="../../assets/tool/tech.png" alt="" class="ch-title__icon" />
                <span class="ch-title__text">技术教程</span>
            </div>
        </div>
        <div class="ch-tabs">
            <el-tabs tab-position="left" class="tabs">
                <el-tab-pane label="技术教程" :lazy="true" class="ch-tabpane">
                    <!-- <a class="link" target="_blank" href="http://47.105.117.217:18080/upload/2021-06-29/ICPTechnical.pdf">技术教程.pdf</a> -->
                      <iframe src="https://icp.top/upload/2021-06-29/ICPTechnical.pdf" width="100%" height="100%" style="min-height: 500px">
                            This browser does not support PDFs. Please download the PDF to view it: <a href="https://icp.top/upload/2021-06-29/ICPTechnical.pdf">Download PDF</a>
                          </iframe>
                </el-tab-pane>
                <!-- <el-tab-pane label="1.	什么是互联网计算机" :lazy="true" >
          <a class="link" target="_blank" >Internet Computer（互联网计算机） 是一种在 Internet 上托管应用程序的新方式，它更安全、更抗审查，并且更易于开发人员使用。Internet Computer通过许多技术创新带来安全性、去中心化和易用性的这些好处，Internet Computer自 2016 年开始开发，2021 年 5 月官方主网正式上线。</a>
        </el-tab-pane>

       
        	<el-tab-pane label="1.	2.	互联网计算机发展简史" :lazy="true" >
          <a class="link" target="_blank" >2016 年 10 月： DFINITY 基金会由总部位于瑞士苏黎世的 Dominic Williams 创立
            <br>
2017 年 2 月：在种子轮筹款中筹集了 420 万美元（比软上限目标高 4 倍），代币众筹价格0.0362美元。
    <br>
2018 年 2 月：从 Andreesen Horowitz 和 Polychain Capital 筹集了 6100 万美元，代币众筹价格1.9美元。
    <br>
2018 年 5 月：在空投中分发了 3500 万美元的 DFINITY 代币
    <br>
2018 年 8 月：从 Andreesen Horowitz、Polychain Capital、SV Angel、Aspect Ventures、Village Global、Multicoin Capital、Scalar Capital 和 Amino Capital、KR1 以及 DFINITY 社区成员筹集了 1.02 亿美元，代币募资成本4.85美金。
    <br>
2019 年 11 月： Copper 发布：SDK 和 Motoko（冶金命名发布的开始）。
    <br>
2020 年 1 月：青铜版本：演示网络。
    <br>
2020 年 6 月： Tungsten 发布：向某些开发者开放测试网络。
    <br>
2020 年 9 月： Sodium Network：公布网络神经系统和 IC 生态系统通证经济。
    <br>
2020 年 12 月： Mercury alpha 版本：推出 Internet Computer 的 alpha 主网。
    <br>
2021 年 5 月： Mercury 官方发布：互联网计算机创世；主网和ICP代币上线。
</a>
        </el-tab-pane>


    
        	<el-tab-pane label="3.	Dfinity项目架构" :lazy="true" >
          <a class="link" target="_blank" >  Dfinity架构包含不同的组件，自下而上由分布于全球各地数据中心、节点、子网和容器等单元组成。以下我们简要定义每一项组建。
图.互联网计算机架构
           <div class="tp">
              <img class="img3" src="../../assets/list/31.jpg" alt="" />
            </div>
数据中心(Data centers)：托管ICP专用硬件节点机器
节点（Nodes）：节点是运行在数据中心的一台机器，节点运行互联网计算机协议提供计算能力。
子网(Subnets)：子网由一组节点机器组成的虚拟网络。在特定子网上运行的任何内容和结果都会在子网中的节点之间复制。
容器(Canisters)：容器是运行在互联网计算机应用程序的代码、状态、内存和存储的集合，容器在子网上运行。
</a>
        </el-tab-pane>


        	<el-tab-pane label="4.	分层模型" :lazy="true" >
          <a class="link" target="_blank" >ICP共识采用分层设计模式，自底向上分别为Identity层，Random Beacon 层，BlockChain 层和Notary 层，每一层负责不同的功能和事务。
            <br>
图.ICP共识分层模型
    <div class="tp">
              <img class="img3" src="../../assets/list/41.png" alt="" />
            </div>
                <div class="tp">
              <img class="img3" src="../../assets/list/42.png" alt="" />
            </div>
</a>
        </el-tab-pane>


        	<el-tab-pane label="5.	互联网计算机共识机制" :lazy="true" >
          <a class="link" target="_blank" > 互联网计算机的共识过程主要由一些可以广播消息的网络节点client参与完成，client主要有三个功能，如上图三个圆圈所;
1 随机数灯塔生成当前轮次的随机数，发给区块生产者和公证委员会
2 区块生产者结合随机数，生成区块提议
3 公证委员会对公证区块进行广播

<br>
    

随机数灯塔
提交委员会负责随机数灯塔和区块公证，当网络规模较小时，该委员会可以包括所有的节点，在规模大的网络里，提交委员会是一个随机选出的clients集合。
负责每个区块的公证委员会都是随机选出的，而且通过非交互BLS签名（不需要节点通信消耗）保证随机性。
每个验证区块的公证委员会都会生成代表该组唯一的签名，这个唯一签名生成就是随机数灯塔，代表互联网计算机的随机数生成器，通过随机数生成负责区块共识的提交委员会
互联网计算机为了防止恶意节点进入委员会的概率，增加了和ETH2.0一样的保证金质押机制。
区块产生
互联网计算机采用的是一种称为「概率插槽协议」的区块生成方式，提交委员会随机数一旦生成，节点就可以开始各自对没有公证过的区块进行签名然后提议到网络。
图.「概率插槽协议」
 <br>
 

   插槽：节点提议的区块都赋予权重，如果单轮次（每个随机数签名σ代表一个轮次）中节点签署多个区块提案，节点就按照权重的高低，将这些区块放到一个“slot”中，不同的插槽对应不同的权重值。
   最长链原理：节点提议的区块都需要引用之前被公证过的区块（即上链的区块），最后选择一条权重加总最长的链作为唯一的主链，而那些选择了权重小的链的节点会自动放弃而选择权重最长链。
区块公证
   区块公证保证节点广播权重最大的区块同时知道何时开始下一轮区块生产。ICP在随机数灯塔选出出块委员会后，委员会所有节点就可以对所有权重优先级最高的区块进行

<br>



签名并广播，在一个预设的Blocktime内，如果一个区块收集到的公证签名最多，那这个区块就会被认为是本轮的公证区块，然后就进入到下一轮
  ICP认为根据它的随机数灯塔每一轮只会确立一个公证区块，所以假设被验证的区块都是一个集合出现偶尔分叉，而DFINITY的概率插槽协议和公证区块则保证这个验证区块的集合经过两个轮次之后可以足够的收敛并形成最一致性
</a>
        </el-tab-pane> -->
            </el-tabs>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
</style>
